import React from 'react';
import "../Figure.css"


function Figure4() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> GFP \ bacteria culture volume​ </th>
              <th> 1 mL </th>
              <th> O.5 mL </th>
              <th> 0.25 mL </th>
              <th> 0.125 mL </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> 0 µg/mL</th>
              <td> 1 600 </td>
              <td> 1 000 </td>
              <td> 1 000 </td>
              <td> 1 600 </td>
            </tr>            
            <tr>
              <th> 60 µg/mL</th>
              <td> 2 000 </td>
              <td> 1 300 </td>
              <td> 1 100 </td>
              <td> 1 500 </td>
            </tr>
            <tr>
              <th> 120 µg/mL</th>
              <td> 2 100 </td>
              <td> 1 300 </td>
              <td> 1 100 </td>
              <td> 1 600 </td>
            </tr>
            <tr>
              <th> 240 µg/mL</th>
              <td> 2 250 </td>
              <td> 1 350 </td>
              <td> 1 100 </td>
              <td> 1 500 </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure4;